module.exports = __webpack_public_path__ + "static/img/pic-line2-En.3ec19b99.jpg";